let elements = {
  //pick: 3,
  blockCheck: true,
  permanent: true,
  mainImage: {
    imagePath: 'games/page005_game1/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page005_game1/audio/false.mp3',
    positive: 'games/page005_game1/audio/4_Lisa.mp3',
    click: 'games/page005_game1/audio/click.mp3',
    icon: {
      on: 'games/page005_game1/img/audioOn.png',
      off: 'games/page005_game1/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 60,
    height: 60,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 165,
    height: 305,
  },
  layoutItems: [
    {
      pos: {
        x: 928,
        y: 738,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 44,
        y: 100,
      },
    },
    {
      pos: {
        x: 509,
        y: 100,
      },
    },
    {
      pos: {
        x: 973,
        y: 100,
      },
    },
    {
      pos: {
        x: 1438,
        y: 100,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: true,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page005_game1/audio/4_Lisa.mp3',
          correct: {
            audioId: 'a03',
            image: {
              src: 'games/page005_game5/img/lisa.png',
            },
            width: 436,
            height: 552,
            correctItems: {
              images: [
                {
                  src: 'games/page005_game1/img/ramka_zielona.png',
                  pos: {
                    y: -6,
                    x: -6,
                  },
                  width: 448,
                  height: 564,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a05',
            image: {
              src: 'games/page005_game5/img/mole.png',
            },
            width: 436,
            height: 552,
            incorrectItems: {
              images: [
                {
                  src: 'games/page005_game1/img/ramka_czerwona.png',
                  pos: {
                    y: -6,
                    x: -6,
                  },
                  width: 448,
                  height: 564,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a05',
            image: {
              src: 'games/page005_game5/img/mole.png',
            },
            width: 436,
            height: 552,
            incorrectItems: {
              images: [
                {
                  src: 'games/page005_game1/img/ramka_czerwona.png',
                  pos: {
                    y: -6,
                    x: -6,
                  },
                  width: 448,
                  height: 564,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a05',
            image: {
              src: 'games/page005_game5/img/mole.png',
            },
            width: 436,
            height: 552,
            incorrectItems: {
              images: [
                {
                  src: 'games/page005_game1/img/ramka_czerwona.png',
                  pos: {
                    y: -6,
                    x: -6,
                  },
                  width: 448,
                  height: 564,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  mbAudioItemData: [
    {
      id: 'a01',
      src: 'games/page005_game1/audio/1_hello.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page005_game1/img/audioOn.png', iconOff: 'games/page005_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 600,
        x: 195,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page005_game1/audio/2_bye_bye.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page005_game1/img/audioOn.png', iconOff: 'games/page005_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 600,
        x: 195,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page005_game1/audio/4_Lisa.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page005_game1/img/audioOn.png', iconOff: 'games/page005_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 600,
        x: 195,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: 'games/page005_game1/audio/6_bear.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page005_game1/img/audioOn.png', iconOff: 'games/page005_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 600,
        x: 195,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      id: 'a05',
      src: 'games/page005_game1/audio/7_mole.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page005_game1/img/audioOn.png', iconOff: 'games/page005_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 600,
        x: 195,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      id: 'a06',
      src: 'games/page005_game1/audio/0_Dusty.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page005_game1/img/audioOn.png', iconOff: 'games/page005_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 600,
        x: 195,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      id: 'a07',
      src: 'games/page005_game1/audio/3_Tom.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page005_game1/img/audioOn.png', iconOff: 'games/page005_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 600,
        x: 195,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
  ],
};

export default elements;
